import React from 'react'
import {
  FormInputSelect,
  FormInput
} from 'camino-react'
import _ from 'lodash'

class Category extends React.Component {
  constructor (props) {
    super()

    this.state = {
      subCategories: []
    }
  }

  showTicketSubCategories = (categoryId) => {
    return !_.isNil(categoryId)
  }

  setSubCategories = (categoryId) => {
    const { categories } = this.props
    this.setState({ subCategories: _.find(categories, ['value', categoryId]).subCategories })
  }

  render () {
    const {
      showTicketSubCategories,
      setSubCategories
    } = this

    const {
    editedItem,
    categories
    } = this.props

    const { subCategories } = this.state

    return (
      <div>
        <FormInput>
          <div key={editedItem.firstValueId}>
            <div>
              <FormInputSelect
                value={_.find(categories, ({ value: editedItem.categoryId }))}
                isLoading={_.isEmpty(categories)}
                options={categories}
                onValue={(value) => {
                  editedItem.updateOptionValue('categoryId', value)
                  setSubCategories(value)
                }}
                clearable
                name="editedItem[categoryId]"
                id="categoryId"
              />
            </div>
          </div>
        </FormInput>
        {showTicketSubCategories(editedItem.categoryId) && (
          <div>
            <FormInput>
              <div key={editedItem.categoryId}>
                <FormInputSelect
                  placeholder="SubCategory"
                  value={_.find(subCategories, ({ value: editedItem.subCategoryId }))}
                  options={subCategories}
                  onValue={value => editedItem.updateOptionValue('subCategoryId', value)}
                  clearable
                  name="editedItem[subCategoryId]"
                  id="subCategory"
                />
              </div>
            </FormInput>
          </div>
        )}
      </div>

    )
  }
}

export default Category